import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MODAL_DATA } from '../../../../../ui/modal/modal-data.token';
import { CheckboxComponent } from '../../../../../ui/checkbox/checkbox.component';
import { FormsModule } from '@angular/forms';
import { MatterWordDocumentWithMetadata } from 'src/app/shared/state/matter/matter-word-documents/matter-word-documents.selectors';

@Component({
	selector: 'ui-edit-package-confirm-modal',
	imports: [CommonModule, CheckboxComponent, FormsModule],
	templateUrl: './edit-package-confirm-modal.component.html',
})
export class EditPackageConfirmModalComponent {
	private _dontShowAgain = false;

	get dontShowAgain(): boolean {
		return this._dontShowAgain;
	}

	set dontShowAgain(value: boolean) {
		this._dontShowAgain = value;
		if (value) {
			localStorage.setItem('ignoreEditPackageInWordWarning', 'true');
		} else {
			localStorage.removeItem('ignoreEditPackageInWordWarning');
		}
	}

	constructor(
		@Inject(MODAL_DATA)
		public data: { wordDocuments: MatterWordDocumentWithMetadata[] },
	) {}

	trackByContent(index: number, content: any): string {
		return content.id;
	}
}
